import React from "react";
import SolutionDetail from "./Components/SolutionDetail";
import FinanceImage from "../../assets/img/graphique-finance-entreprise-du.webp";
import {
  FaAndroid,
  FaApple,
  FaAppStore,
  FaBuilding,
  FaDownload,
  FaIdCard,
  FaLock,
  FaMailBulk,
  FaMapPin,
  FaPeopleArrows,
  FaPhoenixFramework,
  FaRobot,
  FaWindows,
} from "react-icons/fa";
import { CircuitBoardIcon, LucidePartyPopper, User2 } from "lucide-react";
import IntlMessages from "../../intl/IntlMessages";

const FinanceSolution = () => {
  const solutionData = {
    title: <IntlMessages id="software.title" />,
    category: "immofest",
    description: <IntlMessages id="software.description" />,
    imageBg: `url(${FinanceImage})`,
    features: [
      {
        icon: <LucidePartyPopper />,
        title: <IntlMessages id="eventManagement.title" />,
        description: <IntlMessages id="software.place" />,
      },
      {
        icon: <FaBuilding />,
        title: <IntlMessages id="software.mobileBank" />,
        description: <IntlMessages id="software.finance" />,
      },
      {
        icon: <FaMailBulk />,
        title: <IntlMessages id="software.social" />,
        description: <IntlMessages id="software.chat" />,
      },
      {
        icon: <FaPhoenixFramework />,
        title: <IntlMessages id="software.job" />,
        description: <IntlMessages id="software.join" />,
      },
      {
        icon: <FaMapPin />,
        title: <IntlMessages id="software.geoloc" />,
        description: <IntlMessages id="software.location" />,
      },
      {
        icon: <FaRobot />,
        title: <IntlMessages id="software.virtual" />,
        description: <IntlMessages id="software.terminal" />,
      },
      {
        icon: <FaPeopleArrows />,
        title: <IntlMessages id="software.business" />,
        description: <IntlMessages id="software.platform" />,
      },
      {
        icon: <FaLock />,
        title: <IntlMessages id="software.security" />,
        description: <IntlMessages id="software.keep" />,
      },
      {
        icon: <FaBuilding />,
        title: <IntlMessages id="software.services" />,
        description: <IntlMessages id="software.power" />,
      },
    ],
    benefits: [
      <IntlMessages id="software.operation" />,
      <IntlMessages id="software.transaction" />,
      <IntlMessages id="software.conformity" />,
      <IntlMessages id="software.technical" />,
      <IntlMessages id="software.updates" />,
      <IntlMessages id="software.existing" />,
      <IntlMessages id="software.rapid" />,
      <IntlMessages id="software.energy" />,
      <IntlMessages id="software.life" />,
    ],
    targetAudience: [
      {
        icon: <FaIdCard size={25} />,
        title: <IntlMessages id="software.bank" />,
        description: <IntlMessages id="software.institution" />,
      },
      {
        icon: <FaBuilding size={25} />,
        title: <IntlMessages id="software.institute" />,
        description: <IntlMessages id="software.company" />,
      },
      {
        icon: <User2 size={25} />,
        title: <IntlMessages id="software.particular" />,
        description: <IntlMessages id="software.professional" />,
      },
      {
        icon: <CircuitBoardIcon size={25} />,
        title: <IntlMessages id="software.others" />,
        description: <IntlMessages id="software.otherOne" />,
      },
    ],
    modules: [
      {
        title: "Vision",
        features: [
          <IntlMessages id="software.digital" />,
          <IntlMessages id="software.employ" />,
          <IntlMessages id="software.payment" />,
          <IntlMessages id="software.persons" />,
          <IntlMessages id="software.audit" />,
          <IntlMessages id="software.synchrone" />,
        ],
      },
    ],
    customization: {
      description:
      <IntlMessages id="software.download" />,
      options: [
        {
          icon: <FaAndroid size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaAppStore size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaWindows size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
        {
          icon: <FaApple size={25} />,
          download: <FaDownload size={20} />,
          text: <IntlMessages id="software.downloading" />,
        },
      ],
    },
  };

  return <SolutionDetail {...solutionData} />;
};

export default FinanceSolution;
